// Shared finance form-control sizing. These keep dense finance surfaces visually
// quiet while giving buttons and inputs a larger target than the raw label text.
export const financeInlineEditTriggerClass =
  'inline-flex min-h-8 items-center gap-1 rounded-md px-2 py-1 -mx-2 text-left text-inherit transition-colors hover:bg-muted/60 hover:text-primary hover:underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

export const financeFormInputClass =
  'min-h-9 rounded-md border border-input bg-background px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50';

export const financeFormSelectClass =
  'min-h-9 rounded-md border border-input bg-background px-3 py-1.5 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50';

export const financeTextActionClass =
  'inline-flex min-h-8 items-center rounded-md px-2 py-1 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50';

// Shared field label — one size/weight for every finance form control so labels
// stop drifting (some surfaces used text-xs, others text-sm). Sentence case is
// the house style; the label text itself lives at the call site.
export const financeFormLabelClass = 'block text-sm font-medium mb-1';
